import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagementService } from 'src/framework/services/user-management.service';
import { UserList, UserLogsList } from '../entities/user-management';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { FileUpload, MessageService, ConfirmationService } from 'primeng';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageService } from 'src/framework/services/language.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CategoryConstant } from '../shared/app-constants/category-constants';
import { DatePipe } from '@angular/common';
import * as _ from 'lodash';
import { Observable } from 'rxjs-compat';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.css']
})
export class UserManagementComponent implements OnInit {
  userArray: any[];
  cols: { field: string; header: string; }[];
  colmns: { field: string; header: string; }[];
  UserListArray: UserList[];
  mainHeading = "User Management";
  showtable = false;
  displayUserDialog = false;
  chooseImageHeading: string = 'Choose Image';
  userEditForm: FormGroup;
  externalContactModel: EditUser;
  selectedLanguage: any;
  MappedLanguage: any;
  MappedEnglishLanguage: any;
  showError = false;
  disableActive = false;
  userTitles = [];
  UserEmail = '';
  @ViewChild(FileUpload) ctrlImageUpload: FileUpload;
  pUpload: any;
  emailPattern = "[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}";
  isImageUploaded = false;
  imageURL: string;
  isEdit = false;
  base64data: any;
  selectedLanguageId: number;
  defaultEnglishJson: any;
  defaulttitleEnglishJson: any
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  selectedtitleAppLanguageJson: any;
  userlogsArray: any[];
  UserLogsListArray: any[];
  EnglishTitleCodes:any;
  selectedGlobalLanguageJson: any;
  defaultGlobalEnglishJson: any
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  CopyUserListArray:any;

  constructor(private service: UserManagementService, private fb: FormBuilder, private sanitizer: DomSanitizer, private languageService: LanguageService, private messageService: MessageService, private confirmationService: ConfirmationService, private spinner: NgxSpinnerService, private datePipe: DatePipe) {
    this.externalContactModel = new EditUser(false, false, "", "", "", "", "", true, 0);
    this.userEditForm = new FormGroup({
      'userId': new FormControl(this.externalContactModel.userId, [Validators.required]),
      'isAdmin': new FormControl(this.externalContactModel.isAdmin, [Validators.required]),
      'isAuthorized': new FormControl(this.externalContactModel.isAuthorized, [Validators.required]),
      'picture': new FormControl(this.externalContactModel.picture, [Validators.required]),
      'title': new FormControl(this.externalContactModel.title, [Validators.required, Validators.email]),
      'designation': new FormControl(this.externalContactModel.designation, [Validators.required]),
      'linkEnglish': new FormControl(this.externalContactModel.linkEnglish, [Validators.required]),
      'linkFrench': new FormControl(this.externalContactModel.linkFrench, [Validators.required]),
      'isDisplays': new FormControl(true),
      'isActive': new FormControl(true)
    });
  }

  ngOnInit(): void {
    this.spinner.show();

    this.loadLanguageLabel();


    this.getAllRoles();
    this.getAllUserLogs();

    this.languageService.currentData.subscribe(data => this.selectedLanguage = data);


    this.languageService.mySubject.subscribe((data) => {
      //call my function

      var languageMappings = data;
      if (languageMappings.length > 0) {
        var selectedLanguageMappings = languageMappings.filter(item =>
          item.categoryName == "Global" && item.languageId == this.selectedLanguage['Id']);
        this.MappedLanguage = JSON.parse(selectedLanguageMappings[0].languageMappingJSON);
        var englishLanguageMappings = languageMappings.filter(item =>
          item.categoryName == "Global" && item.languageId == 1);
        this.MappedEnglishLanguage = JSON.parse(englishLanguageMappings[0].languageMappingJSON);
      }




    });
  }

  cancel() {
    this.onReset()
  }

  deleteUser(rowData: any) {
    this.confirmationService.confirm({
      message: this.labelReplacer('AreyousurethatyouwanttodeletethisUser'),
      accept: () => {
        this.spinner.show();
        this.service.deleteUser(rowData.userId).subscribe((response) => {
          if (response.responseStatus == 1) {

          } else {
            this.messageService.add({ severity: 'success', summary: this.labelReplacer('UserDeleted'), detail: this.labelReplacer('UserDetailshasbeenDeletedSuccessfully') });
          }
          this.getAllRoles();
          this.getAllUserLogs();
          this.spinner.hide();
        });
      }
    });

  }

  onRowEditInit(row: any) {
    this.userEditForm.controls['userId'].setValue(row.userId);
    this.userEditForm.controls['isAdmin'].setValue(row.isAdmin);
    this.userEditForm.controls['isAuthorized'].setValue(row.isAuthorized);
    if (row.title != null) {
      this.userEditForm.controls['title'].setValue(row.title);
    }
    this.userEditForm.controls['designation'].setValue(row.designation);
    this.userEditForm.controls['linkEnglish'].setValue(row.linkEnglish);
    this.userEditForm.controls['linkFrench'].setValue(row.linkFrench);
    this.userEditForm.controls['isDisplays'].setValue(row.is_Display);
    this.userEditForm.controls['isActive'].setValue(row.activeEmployee);
    if (row.businessUnitCode == 'CA814') {
      this.disableActive = true;
    }
    else {
      this.disableActive = false;
    }
    if (row.picture != "") {
      
      this.service.downloadImage(row.picture)
        .subscribe((data : any)=> {
          this.displayUserDialog = true;
          this.ctrlImageUpload.files.push(new File([data], row.picture));
          this.pUpload = new File([data], row.picture);
          var blob = new Blob([data], { type: "image/png" });

          var reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => {
            var base64data = reader.result;
            this.imageURL = this.sanitizer.bypassSecurityTrustUrl(base64data.toString()) as string;
          }

        });
    }
    else {
      this.displayUserDialog = true;
    }
  }

  onUpload(event) {
    for (const file of event.files) {
      this.pUpload = file;
      const reader = new FileReader();
      reader.onload = () => {
        this.imageURL = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
    this.isImageUploaded = true;
  }
  onRemove(event) {
    this.pUpload = null;
    this.imageURL = '';
  }

  onReset() {
    this.userEditForm.reset();
    this.pUpload = null;
    this.imageURL = '';
    this.ctrlImageUpload['files'] = [];
    this.isImageUploaded = false;
    this.isEdit = false;
    this.displayUserDialog = false;
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishtitleLanguageMappings, selectedtitleLanguageMappings: any;
    let englishglobalLanguageMappings, selectedglobalLanguageMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;

    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          this.EnglishTitleCodes = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Title.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.UserManagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishtitleLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Title.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishglobalLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];


          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.UserManagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedtitleLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Title.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedglobalLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.UserManagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedtitleLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Title.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedglobalLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedtitleLanguageMappings = englishtitleLanguageMappings;
              selectedglobalLanguageMappings = englishglobalLanguageMappings;
              selectedLangDateMappings = englishDateMappings;

            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedtitleAppLanguageJson = JSON.parse(selectedtitleLanguageMappings.languageMappingJSON);
          this.defaulttitleEnglishJson = JSON.parse(englishtitleLanguageMappings.languageMappingJSON);

          this.selectedGlobalLanguageJson = JSON.parse(selectedglobalLanguageMappings.languageMappingJSON);
          this.defaultGlobalEnglishJson = JSON.parse(englishglobalLanguageMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          var Titles=Object.keys(JSON.parse(this.EnglishTitleCodes.languageMappingJSON));

          this.cols = [
            { field: 'gpn', header: this.labelReplacer('GPN') },
            { field: 'activeEmployee', header: this.labelReplacer('ActiveEmployee') },
            { field: 'firstName', header: this.labelReplacer('PrefferedSearchName') },
            { field: 'lastName', header: this.labelReplacer('LastName') },
            { field: 'rankCode', header: this.labelReplacer('RankCode') },
            { field: 'rankName', header: this.labelReplacer('RankName') },
            { field: 'subServiceLine', header: this.labelReplacer('SubServiceLine') },
            { field: 'serviceLine', header: this.labelReplacer('ServiceLine') },
            { field: 'locationCity', header: this.labelReplacer('LocationCity') },
            { field: 'emailId', header: this.labelReplacer('EmailAddress') },
            { field: 'isAdmin', header: this.labelReplacer('SuperAdmin') },
            { field: 'isAuthorized', header: this.labelReplacer('IsAuthorized') },
            { field: 'picture', header: this.labelReplacer('Picture') },
            { field: 'title', header: this.labelReplacer('Title') },
            { field: 'designation', header: this.labelReplacer('Designation') },
            { field: 'linkEnglish', header: this.labelReplacer('EnglishLink') },
            { field: 'linkFrench', header: this.labelReplacer('FrenchLink') },
            { field: 'is_Display', header: this.labelReplacer('Display') }
          ];
          Titles.forEach(item=>{
            this.userTitles.push({'label':this.titleReplacer(item),'value':item});
          })
          this.colmns = [
            { field: 'gpn', header: this.labelReplacer('GPN') },
            { field: 'activeEmployee', header: this.labelReplacer('ActiveEmployee') },
            { field: 'firstName', header: this.labelReplacer('PrefferedSearchName') },
            { field: 'lastName', header: this.labelReplacer('LastName') },
            { field: 'rankCode', header: this.labelReplacer('RankCode') },
            { field: 'rankName', header: this.labelReplacer('RankName') },
            { field: 'subServiceLine', header: this.labelReplacer('SubServiceLine') },
            { field: 'serviceLine', header: this.labelReplacer('ServiceLine') },
            { field: 'locationCity', header: this.labelReplacer('LocationCity') },
            { field: 'emailId', header: this.labelReplacer('EmailAddress') },
            { field: 'isAdmin', header: this.labelReplacer('SuperAdmin') },
            { field: 'isAuthorized', header: this.labelReplacer('IsAuthorized') },
            { field: 'picture', header: this.labelReplacer('Picture') },
            { field: 'title', header: this.labelReplacer('Title') },
            { field: 'designation', header: this.labelReplacer('Designation') },
            { field: 'linkEnglish', header: this.labelReplacer('EnglishLink') },
            { field: 'linkFrench', header: this.labelReplacer('FrenchLink') },
            { field: 'is_Display', header: this.labelReplacer('Display') },
            { field: 'logModifiedBy', header: this.labelReplacer('ModifiedBy') },
            { field: 'logModifiedDate', header: this.labelReplacer('ModifiedDate') }
          ];

          // this.userTitles = [{ label: this.titleReplacer('Chairman'), value: 'Chairman' },
          // { label: this.titleReplacer('President'), value: 'President' },
          // { label: this.titleReplacer('Senior Vice President'), value: 'Senior Vice President' },
          // { label: this.titleReplacer('Vice President'), value: 'Vice President' },
          // { label: this.titleReplacer('Manager'), value: 'Manager' },
          // { label: this.titleReplacer('Senior'), value: 'Senior' },
          // { label: this.titleReplacer('Staff'), value: 'Staff' },
          // { label: this.titleReplacer('Consultant'), value: 'Consultant' },
          // { label: this.titleReplacer('Senior Manager'), value: 'Senior Manager' },
          // { label: this.titleReplacer('Partner'), value: 'Partner' },
          // { label: this.titleReplacer('Associate Partner'), value: 'Associate Partner' },
          // { label: this.titleReplacer('Executive Director'), value: 'Executive Director' }
          // ];
          this.islabelLoaded = true;
          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {
        console.log(err);
      });
  }


  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else if (arr?.length == 4)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2] + ' ' + arr[3];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }


  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  getAllRoles() {
    this.userArray = [];
    this.UserListArray = [];
    this.service.getAllUsers()
      .subscribe
      (
        (resp) => {
          this.userArray = resp.data;
          this.userArray.forEach((item) => {
            var userList = new UserList(
              item.gpn,
              item.isActive,
              item.firstName,
              item.lastName,
              item.rankCode,
              item.rankName,
              item.subserviceLine,
              item.serviceLine,
              item.locationCity,
              item.emailId,
              item.isAdmin,
              item.isAuthorized,
              item.picture,
              item.title,
              item.designation,
              item.linkEnglish,
              item.linkFrench,
              item.is_Display,
              item.businessUnitCode,
              item.userId
            );
            this.UserListArray.push(userList);
            
          });
          this.CopyUserListArray = _.cloneDeep(this.UserListArray);
          this.UserListArray=this.UserListArray.filter(item=>item.activeEmployee==true);
          this.showtable = true;
          this.spinner.hide();
        }
      );
  }


  getAllUserLogs() {
    this.userlogsArray = [];
    this.UserLogsListArray = [];
    this.service.getAllUserLogs()
      .subscribe
      (
        (resp) => {
          this.userlogsArray = resp.data;
          this.userlogsArray.forEach((item) => {
            var userList = new UserLogsList(
              item.userLogsId,
              item.gpn,
              item.isActive,
              item.firstName,
              item.lastName,
              item.rankCode,
              item.rankName,
              item.subserviceLine,
              item.serviceLine,
              item.locationCity,
              item.emailId,
              item.isAdmin,
              item.isAuthorized,
              item.picture,
              item.title,
              item.designation,
              item.linkEnglish,
              item.linkFrench,
              item.is_Display,
              item.businessUnitCode,
              item.userId,
              item.logCreatedBy,
              item.logModifiedBy,
              item.logCreatedDate,
              item.logModifiedDate
            );
            this.UserLogsListArray.push(userList);
          });
          this.showtable = true;
          this.spinner.hide();
        }
      );
  }

  addUser() {
    if (this.UserEmail != "") {

      var users = new UserList();
      users.emailId = this.UserEmail;
      this.service.addUser(users).subscribe(res => {
        if (res.data != null) {
          this.messageService.add({ severity: 'success', summary: this.labelReplacer('UserAdded'), detail: this.labelReplacer('UserDetailshasbeenAddedSuccessfully') });
          // success
          this.UserEmail = "";
          this.getAllRoles();
          this.getAllUserLogs();
          console.log(res);
        } else {
          this.messageService.add({ severity: 'error', summary: this.labelReplacer('IncorrectEmailId'), detail: res.message });

        }
      });

    }
    else {
      this.showError = true;
    }
  }

  titleReplacer(labelKey): string {
    return this.selectedtitleAppLanguageJson[labelKey]?.trim() ? this.selectedtitleAppLanguageJson[labelKey] ?? labelKey : this.defaulttitleEnglishJson[labelKey] ?? labelKey;
  }

  activeReplacer(labelKey): string {
    return this.selectedGlobalLanguageJson[labelKey]?.trim() ? this.selectedGlobalLanguageJson[labelKey] ?? 'text not found' : this.defaultGlobalEnglishJson[labelKey] ?? 'text not found';
  }



  saveEditedUser() {
    this.spinner.show();
    const formData = new FormData();
    this.externalContactModel;
    let imageData;
    imageData = {
      'userId': this.userEditForm.get('userId').value,
      'isAdmin': this.userEditForm.get('isAdmin').value,
      'isAuthorized': this.userEditForm.get('isAuthorized').value,
      'title': this.userEditForm.get('title').value,
      'designation': this.userEditForm.get('designation').value,
      'linkEnglish': this.userEditForm.controls['linkEnglish'].value,
      'linkFrench': this.userEditForm.controls['linkFrench'].value,
      'isDisplay': this.userEditForm.get('isDisplays').value,
      'isActive': this.userEditForm.get('isActive').value,
      'picFileName': ''
    }
    if (this.pUpload) {

      const fileToUpload = <File>this.pUpload;

      formData.append('file', fileToUpload, fileToUpload.name);
      imageData.picFileName = fileToUpload.name;
    }
    formData.append('fileJson', JSON.stringify(imageData));
    this.service.uploadProfilePhoto(formData).subscribe(res => {

      if (res) {
        this.spinner.hide();
        // success
        this.messageService.add({ severity: 'success', summary: this.labelReplacer('UserUpdated'), detail: this.labelReplacer('UserDetailshasbeenUpdatedSuccessfully') });
        this.onReset();
        this.getAllRoles();
        this.getAllUserLogs();
      } else {
        this.spinner.hide();
        // display error
        this.onReset();
      }

    });
  }

  onToggleView(event) {
    this.UserListArray=[];
    let flag = event.checked;
    this.UserListArray=this.CopyUserListArray.filter(item=>item.activeEmployee!=flag);    
  }



  labelReplacer(labelKey) {
    var data = this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
    return data;
  }



}

export class EditUser {
  isAdmin: boolean;
  isAuthorized?: boolean;
  picture?: string;
  title?: string;
  designation?: string;
  linkEnglish?: string;
  linkFrench?: string;
  isDisplay?: boolean;
  userId: number;
  constructor(isAdmin: boolean, isAuthorized: boolean, picture: string, title: string, designation: string, linkEnglish: string, linkFrench: string, isDisplay: boolean, UserId: number) {
    this.userId = UserId;
    this.isAdmin = isAdmin;
    this.isAuthorized = isAuthorized;
    this.picture = picture;
    this.title = title;
    this.designation = designation;
    this.linkEnglish = linkEnglish;
    this.linkFrench = linkFrench;
    this.isDisplay = isDisplay;
  }
}
